<template>
  <div class="col-9">
    <div class="px-4 text-center my-4 border-bottom">
      <h5 class="fw-bold">სერტიფიკატი</h5>
      <p class="text-secondary small mb-4">
        ძვირფასო მომხმარებელო, თქვენი სერტიფიკატი სერვერზე 2 კვირით
        შეინახება,<br />
        ამიტომ გთხოვთ, ის აღნიშნული პერიოდის განმავლობაში ჩამოტვირთოთ.
      </p>
    </div>
    <div v-if="data" class="w-75 mx-auto mb-5">
      <p v-if="data.success === false" class="text-center alert alert-danger">
        {{ data.message }}
      </p>
      <div v-else class="text-center">
        <a :href="`${backUrl}/uploads/files/${data.data.certificate}`" target="_blank" class="btn btn-outline-primary rounded-pill px-4 me-3"><span class="material-icons align-middle">picture_as_pdf</span> <span>გადმოწერა</span></a>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from "@/http";
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";

const backUrl = process.env.VUE_APP_BACK_URL
const data = ref(false)

const props = defineProps({
  store: {
    type: Object,
    required: true
  }
})

onMounted(async () => {
  const res = await axios.post(
    '/getCertificate',
    { userId: props.store.state.user.id },
    { headers: { Authorization: `Bearer ${props.store.state.token}` } }
  );

  data.value = res.data
})


</script>

<style>
</style>